/**
 * 设备相关
 */
import axios from "../axios";
import {
    IEquipmentCreateParams,
    IEquipmentEditParams,
    IEquipmentGetData,
    IEquipmentGetMonitorImgData,
    IEquipmentGetMonitorImgParams,
    IEquipmentImportData,
    IEquipmentImportParams,
    IEquipmentListAllData,
    IEquipmentListData,
    IEquipmentListParams,
    IEquipmentListSelectParams,
    IEquipmentRepeatAddParams,
    IEquipmentSensorImportData,
    IEquipmentSensorImportParams,
    IEquipmentSettingCoordinatesParams,
    IEquipmentSortingParams,
    IEquipmentTypeCheckParams,
    IEquipmentTypeListData,
    IEquipmentTypeListParams,
    IEquipmentTypeModelListItem,
    IEquipmentUploadImageParams,
    IGetEquipmentListByAreaIdData
} from "./equipment.types";

/**
 * 根据区域ID获取设备 
 */
export function getEquipmentListByAreaId(areaId: number) {
    return axios<IGetEquipmentListByAreaIdData>({
        method: 'get',
        url: `/equipment/list/${areaId}`
    })
}

/**
 * 获取单个设备
 */
export function equipmentGet(params: { equipmentId: number }) {
    return axios<IEquipmentGetData>({
        method: 'get',
        url: '/equipment/get',
        params,
    })
}

/**
 * 设备删除 
 */
export function equipmentDelete(params: { id: number }) {
    return axios<boolean>({
        method: 'get',
        url: '/equipment/del',
        params,
    })
}

/**
 * 设备管理 - 新增设备 
 */
export function equipmentCreate(params: IEquipmentCreateParams) {
    return axios<void>({
        method: 'post',
        url: '/equipment/save',
        data: params,
    })
}

/**
 * 设备管理 - 编辑设备 
 */
export function equipmentEdit(params: IEquipmentEditParams) {
    return axios<void>({
        method: 'post',
        url: '/equipment/edit',
        data: params,
    })
}

/**
 * 设备配置 - 根据设备类型ID获取配件和模型数据
 */
export function equipmentTypeModelList(params: { equipmentTypeId: number }) {
    return axios<IEquipmentTypeModelListItem>({
        method: 'get',
        url: '/equipment/typeModel/get',
        params,
    })
}


/**
 * 获取设备类型list
 */
export function equipmentTypeList(params: IEquipmentTypeListParams) {
    return axios<IEquipmentTypeListData>({
        method: 'get',
        url: '/equipment/type/list',
        params,
    })
}

/**
 * 新增设备类型名称
 */
export function equipmentTypeAdd(params: { name: string, companyId: number }) {
    return axios({
        method: 'post',
        url: '/equipment/type/add',
        params,
    })
}

/**
 * 根据设备类型ID获取模型配置
 */
export function equipmentTypeGet(params: { equipmentTypeId: number }) {
    return axios({
        method: 'post',
        url: '/equipment/type/get',
        params,
    })
}

/**
 * 设备管理 - 设备分页列表
 */
export function equipmentList(params: IEquipmentListParams) {
    return axios<IEquipmentListData>({
        method: 'post',
        url: '/equipment/findPage',
        data: params,
    })
}

/**
 * 设备管理 - 获取设备
 */
export function equipmentListAll() {
    return axios<IEquipmentListAllData>({
        method: 'post',
        url: '/equipment/findList',
        data: {}
    })
}

/**
 * 设备管理 - 模糊搜索
 */
export function equipmentListSelect(params: IEquipmentListSelectParams) {
    return axios<IEquipmentListAllData>({
        method: 'get',
        url: '/equipment/listSelect',
        params
    })
}


/**
 * 收藏设备
 */
export function equipmentCollect(params: { equipmentId: number }) {
    return axios({
        method: 'get',
        url: '/equipment/collect',
        params,
    })
}

/**
 * 设备类型判断
 */
export function equipmentTypeCheck(params: IEquipmentTypeCheckParams) {
    return axios({
        method: 'post',
        url: '/equipment/type/check',
        params,
    })
}

/**
 * 导入
 */
export function equipmentImport(params: IEquipmentImportParams) {
    const formData = new FormData()
    formData.append('file', params.file)
    return axios<IEquipmentImportData>({
        method: 'post',
        url: '/equipment/importFile',
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

/**
 * 重复设备添加
 */
export function equipmentRepeatAdd(params: IEquipmentRepeatAddParams) {
    return axios({
        method: 'post',
        url: '/equipment/equipmentRepeatAdd',
        data: params,
    })
}

/**
 * 设备排序 
 */
export function equipmentSorting(params: IEquipmentSortingParams) {
    return axios({
        method: 'post',
        url: '/equipment/equipmentSorting',
        data: params
    })
}

/**
 * 设备图片上传 
 */
export function equipmentUploadImage(params: IEquipmentUploadImageParams) {
    return axios({
        method: 'post',
        url: '/equipment/uploadEquipmentImg',
        data: params
    })
}

/**
 * 通过测点ID获取设备总貌图
 */
export function equipmentGetMonitorImg(params: IEquipmentGetMonitorImgParams) {
    return axios<IEquipmentGetMonitorImgData>({
        method: 'get',
        url: '/equipment/getEquipmentMonitorImg',
        params
    })
}

/**
 * 设备坐标设置 
 */
export function equipmentSettingCoordinates(params: IEquipmentSettingCoordinatesParams) {
    return axios({
        method: 'post',
        url: '/equipment/settingCoordinates',
        data: params
    })
}

/**
 * 设备测点传感器导入
 */
export function equipmentSensorImport(params: IEquipmentSensorImportParams) {
    const formData = new FormData()
    formData.append('file', params.file)
    return axios<IEquipmentSensorImportData>({
        method: 'post',
        url: '/equipment/sensor/importFile',
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}
